import React, { useEffect, useState } from 'react';
import technologyData  from './utils/Data/technologyData.js';

const TechnologiesUsed = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const technologiesSection = document.getElementById('technologies');
      const windowHeight = window.innerHeight;
      const triggerPosition = windowHeight * 0.8;

      setIsVisible(
        technologiesSection.offsetTop < window.scrollY + triggerPosition
      );
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const technologyCards = document.querySelectorAll('.technology-card');
    if (isVisible) {
      technologyCards.forEach((card, index) => {
        setTimeout(() => {
          card.classList.add('slidein-anim');
        }, index * 100);
      });
    } else {
      technologyCards.forEach((card) => {
        card.classList.remove('slidein-anim');
      });
    }
  }, [isVisible]);

  return (
    <section
      id="technologies"
      className={`technologies ${isVisible ? 'slideup-anim' : ''}`}
    >
      <h2 className="title">Technologies Utilisées</h2>
      <div className="technologies__list">
        {technologyData.map((tech, index) => (
          <div className="technology-card" key={index}>
            <img src={tech.image} alt={tech.name} />
            <h3>{tech.name}</h3>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TechnologiesUsed;
